import { AlignCenter, AlignLeft, AlignRight, Apple, ArrowLeftRight, ArrowUpDown, Circle, FileSpreadsheet, Frame, GalleryVertical, GalleryVerticalEnd, Grid2x2Check, Hash, Languages, LanguagesIcon, LaptopMinimal, LayoutList, Minus, NotepadText, Palette, Plus, SmartphoneCharging, Square, Squircle, TabletSmartphone } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import fallback_img from "../../../img/fallback_img.jpg"
import loading_img from "../../../img/loadingImg.jpg"
import Toggle from "../../../UI/Toggle";
import RangeSlider from "../../../UI/RangeSlider";
import RangeSliderBasic from "../../../UI/RangeSliderBasic";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import ColorPicker from "../../../UI/ColorPicker/Colorpicker";
import ColorPickerDynamic from "../../../UI/ColorPicker/ColorPickerDynamic";
import ColumnsUISettings from "./ColumnsUISettings";
import LayoutUISettings from "./LayoutUISettings";
import ContentCardUISettings from "./ContentCardUISettings";
import VariationSectionTemplates from "./VariationSectionTemplates";
const WebUISettings = ({setCloseVariationPopUp,blockType, currentContentIndex,setItemArrCurrent,cards,setCards,sendBackImagesArray,dynamicId,scrollItems, setScrollItems,columnsList, setColumnsList,fontFamily, setFontFamily,
  layoutSettings, setLayoutSettings
    ,iWidth, setiWidth,iHeight, setiHeight,
    titleFontSize, setTitleFontSize,subTitleFontSize, setSubTitleFontSize,titleFontColor, setTitleFontColor,subTitleFontColor, setSubTitleFontColor,
    titleFontWeight, setTitleFontWeight,subTitleFontWeight, setSubTitleFontWeight,
    borderRadius, setBorderRadius,marginLeft, setmarginLeft
    ,marginTop, setmarginTop,marginBottom, setmarginBottom,imarginLeft, setimarginLeft,imarginTop, setimarginTop,aspectRatio, setAspectRatio,
    showTitle, setShowTitle, showSubTitle, setShowSubTitle,textAlignment, setTextAlignment,textPosition, setTextPosition,
    applyOverlay,setApplyOverlay,overlayTitleFontColor, setOverlayTitleFontColor,overlayBG, setOverlayBG,

    

absoluteHorizontal,setAbsoluteHorizontal,absoluteVertical,setAbsoluteVertical,
absoluteHorizontalMargin,setAbsoluteHorizontalMargin,absoluteVerticalMargin,setAbsoluteVerticalMargin,
  
itemVisibility,setItemVisibility,
itemBackground, setItemBackground,setItemArr
}) => {
 const fonts=[
  {name:"AlumniSansSC-Regular",
  fontFamily:"AlumniSansSCRegular , 'Helvetica Neue',sans-serif"
 }
 ,{name:"AlumniSansSC-Italic",
  fontFamily:"AlumniSansSCItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Regular",
  fontFamily:"InterRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Italic",
  fontFamily:"InterItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Lato-Light",
  fontFamily:"LatoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Montserrat-Light",
  fontFamily:"MontserratLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Poppins-Regular",
  fontFamily:"PoppinsRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Light",
  fontFamily:"RalewayLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Thin",
  fontFamily:"RalewayThin , 'Helvetica Neue',sans-serif"
 }

];

      const dispatch = useDispatch();  
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
     
   const [itemImages, setItemImages] = useState(cards);
  

  const [columns, setColumns] = useState(columnsList);
  const [layoutSettingsInn, setLayoutSettingsInn] = useState(layoutSettings);
  const [activeSetting, setActiveSetting] = useState("contents");
const [scrollStatusLocal, setScrollStatusLocal] = useState(scrollItems);
const [aspectRatioLocal, setAspectRatioLocal] = useState(aspectRatio);
const [resolution, setPxPercent] = useState('px');
const [cornerType, setCornerType] = useState('');
const [textAlignmentLocal, setTextAlignmentLocal] = useState(textAlignment);
const [itemBackgroundLocal, setItemBackgroundLocal] = useState(itemBackground);
const [palletBG, setPalletBG] = useState(false);
const [palletBGTitle, setPalletBGTitle] = useState(false);
const [palletTitleOverlay, setPalletTitleOverlay] = useState(false);
const [palletOverlayBG, setPalletOverlayBG] = useState(false);
const [palletBGSubTitle, setPalletBGSubTitle] = useState(false);
const [absoluteVerticalLocal, setAbsoluteVerticalLocal] = useState(absoluteVertical);
const [loadAbsoluteSliderStatus, setLoadAbsoluteSliderStatus] = useState(true);
const [marginVerticalBoth, setMarginVerticalBoth] = useState(true);
 
 const [textPositionLocal ,setTextPositionLocal]  = useState(textPosition);
 const [fontFamilyPopup ,setFontFamilyPopup]  = useState(false);
 const [fontfamilyNameLocal ,setFontfamilyNameLocal]  = useState(fontFamily?.name);
 const [itemVisibilityLocal ,setItemVisibilityLocal]  = useState(itemVisibility);
                    
                    
                            const [activeColorPickerValueBG,setActiveColorPickerValueBG]=useState(itemBackgroundLocal)
                            const [activeColorPickerValueTitle,setActiveColorPickerValueTitle]=useState(titleFontColor)
                            const [activeColorPickerValueOverlayBG,setActiveColorPickerValueOverlayBG]=useState(overlayBG)
                             const [activeColorPickerValueOverlayTitle,setActiveColorPickerValueOverlayTitle]=useState(overlayTitleFontColor)
                            const [activeColorPickerValueSubTitle,setActiveColorPickerValueSubTitle]=useState(subTitleFontColor)

 
useEffect(()=>{ 

   setScrollStatusLocal(scrollItems)
   setAspectRatioLocal(aspectRatio);
  //  blockType=="design"? setActiveSetting("design"):setActiveSetting("contents");
  setActiveSetting("contents");
},[])


const updateScrollItems=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          scrollItems:val };
      }
     
      return item;
    });

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
const updateItemImages=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          cards:val };
      }
     
      return item;
    });

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
 const updateShowTitle=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          showTitle:val };
      }
     
      return item;
    });
   
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
} 

const updateTitleFontSize=(val)=>{

setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          titleFontSize:val };
      }
     
      return item;
    });
  
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}
const updateTitleFontColor=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          titleFontColor:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}
const updateApplyOverlay=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          applyOverlay:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}
const updateOverlayBG=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          overlayBG:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}

const updateItemVisibility=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          itemVisibility:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}
const updateOverlayTitleFontColor=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          overlayTitleFontColor:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}

const updateSubTitleFontSize=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          subTitleFontSize:val };
      }
     
      return item;
    });

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateSubTitleFontColor=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          subTitleFontColor:val };
      }
     
      return item;
    });
   
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}


const updateShowSubTitle=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          showSubTitle:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}




const updateAspectRatio=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
        return {
          ...item,
          aspectRatio:val };
      }
     
      return item;
    });
     
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateiMarginLeft=(val)=>{
   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return {  ...item,   imarginLeft:val }; }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}



const updateiMarginTop=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return { ...item,   imarginTop:val }; }  return item;   });
  
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateMarginBottom=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return { ...item,   marginBottom:val }; }  return item;   });
  
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateMarginLeft=(val)=>{
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return {   ...item,   marginLeft:val }; } return item; });
   
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
const updateMarginTop=(val)=>{
   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {  return { ...item,  marginTop:val };}  return item; });
  
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateBorderRadius=(val)=>{
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {  return {  ...item,  borderRadius:val };  } return item;});

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
const updateFontFamily=(val)=>{
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {  return {   ...item,   fontFamily:val };}return item;  });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateTextAlignment=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) {  return { ...item, textAlignment:val };  } return item; });

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}



const updateItemBackground=(val)=>{
 setItemArr((prev) => {
  const updatedItems = prev.map(item => { 
     if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return { ...item, itemBackground:val };}  return item; });   setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
const updateiWidth=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return {  ...item, iWidth:val };} return item; });  setItemArrCurrent(updatedItems);return updatedItems;;  });
}
const updateTextPosition=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return {  ...item, textPosition:val };} return item; });  setItemArrCurrent(updatedItems);return updatedItems;;  });
}

const updateAbsoluteVerticalMargin=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return {  ...item, absoluteVerticalMargin:val };} return item; });  setItemArrCurrent(updatedItems);return updatedItems;;  });
}
const updateAbsoluteVertical=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item?.contents[currentContentIndex]?.myKey === dynamicId) { return {  ...item, absoluteVertical:val };} return item; });  setItemArrCurrent(updatedItems);return updatedItems;;  });
}


  return (<div  > 
     
       <div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",marginBottom:"10px",paddingTop:"5px"}}>  
                {/* {blockType=="design"? */}
                 
                  {/* :""} */}
                  
                   <div style={{background:activeSetting=="contents"?"rgba(144, 202, 249,1)":"#ffffff",width:"70px",color:activeSetting=="contents"?"#ffffff":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSetting("contents")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Contents</div>  
                        <div style={{background:activeSetting=="design"?"rgba(144, 202, 249,1)":"#ffffff",width:"70px",color:activeSetting=="design"?"#ffffff":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSetting("design")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Design</div>       
                   {blockType!=="design"? 
                   <div style={{background:activeSetting=="ThemeVariatons"?"rgba(144, 202, 249,1)":"#ffffff",width:"70px",color:activeSetting=="ThemeVariatons"?"#ffffff":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSetting("ThemeVariatons")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Variations</div> :"" }
                       
               </div>
 {/* <div style={{display:"flex",justifyContent:"left",color:"#444444",borderRadius:"15px",fontSize:"19px",fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px"}}>
       Edit List 1</div>          */}
<div className="appSettingsScroller" >
   {activeSetting=="contents"?<div style={{background:"#ffffff",borderRadius:"15px"}}>  
                           
              
           { itemImages?.length===0?  <div  style={{
            display:"flex",flexDirection: 'row',
    justifyContent: 'center',padding:"5px",
    marginBottom: 10}}>
           <img
        src={fallback_img }
        alt=""
       
        style={{
          borderRadius: "10px",
        
          width: "50%",
          marginTop: "10px",border:"3px solid rgba(144, 202, 249,1)",
        //   display: isLoaded && !hasError ? "block" : "none",
        }}
      /></div>:""}  
           { <ContentCardUISettings currentContentIndex={currentContentIndex} dynamicId={dynamicId}
                 cards ={cards} sendBackArray={(val)=>{ setCards(val);}}
                setItemArr={(val)=>{setItemArr(val)}} setItemArrCurrent={(val)=>{setItemArrCurrent(val)}}
                /> }
      
      
          </div> :""}  
    {activeSetting=="design"?<> 
       <LayoutUISettings  currentContentIndex={currentContentIndex} dynamicId={dynamicId}
                layoutSettings={layoutSettings} setLayoutSettings={(val)=>{setLayoutSettings(val)}} 
                setItemArr={(val)=>{setItemArr(val)}} setItemArrCurrent={(val)=>{setItemArrCurrent(val)}}
              />
              </>:""}
                 {activeSetting=="ThemeVariatons"&&itemImages?.length?
                 <div>

                  <button  onClick={()=>setCloseVariationPopUp(true)}   style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" VariationPopUpBtn"  type="submit"
 >+ Create New </button><style>{`
.VariationPopUpBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  `}</style>{}
                 </div> : ""}
          {!cards?.length&& <div
                  className="drop-zone posRelative "
                 
                  style={{
                    height:'100px',position:'relative',left:"5px",right:"5px",
                    backgroundColor:  'rgba(144, 202, 249,0.2) ' , // Change color on hover
                    border:  '0px dashed rgba(144, 202, 249,1) ' , // Change color on hover
                    transition: 'background-color  0.3s ease',width:"95%",
                    borderRadius: '10px',marginTop:"20px"
                   
                  ,marginBottom:"20px"
                   
                  ,display:"flex",justifyContent:"center",
                   visibility:"visible",fontSize:"18px",fontWeight:"bold"
                  }}
                ><div style={{paddingTop:"40px",}}>Select Any Element </div><div className="showPlusElement" ></div>
           </div>} 
           
          {!itemImages?.length&& <div
                  className="drop-zone posRelative "
                 
                  style={{
                    height:'100px',position:'relative',left:"5px",right:"5px",
                    backgroundColor:  'rgba(144, 202, 249,0.2) ' , // Change color on hover
                    border:  '0px dashed rgba(144, 202, 249,1) ' , // Change color on hover
                    transition: 'background-color  0.3s ease',width:"95%",
                    borderRadius: '10px',marginTop:"20px"
                   
                  ,marginBottom:"20px"
                   
                  ,display:"flex",justifyContent:"center",
                   visibility:"visible",fontSize:"18px",fontWeight:"bold"
                  }}
                ><div style={{paddingTop:"40px",}}>Content Not Found </div><div className="showPlusElement" ></div>
           </div>}  
        </div>       
                             </div> );
};


export default WebUISettings;
